import { CardFieldsContainer } from 'payments/components/CardFieldsContainer';
import { useClover } from 'payments/hooks/useClover';
import { CloverPaymentFormProvider } from 'payments/providers/CloverPaymentFormProvider';
import { useModal } from 'reservations/base/providers/ModalProvider';

export interface PaymentInformationProps {
  bookingDate: string;
}

export const CloverPaymentInformation = ({
  bookingDate,
  children
}: React.PropsWithChildren<PaymentInformationProps>) => {
  const { cardFieldStates, handleCardSubmit, setCardFieldStates } = useClover();
  const {
    modalContext: { cardDeclinedError }
  } = useModal();

  return (
    <CloverPaymentFormProvider
      bookingDate={bookingDate}
      handleCardSubmit={handleCardSubmit}
      setCardFieldStates={setCardFieldStates}
    >
      <CardFieldsContainer
        cardFieldStates={cardFieldStates}
        cardDeclinedError={cardDeclinedError}
      />
      {children}
    </CloverPaymentFormProvider>
  );
};
